<template>
	<div class="FreshCabinet" @click="dblBtn()" :style="{ backgroundImage: 'url('+ bgImg +')',backgroundSize: 'cover', backgroundRepeat:'no-repeat' }">
		<div class="languageBtn">
			<div class="lgBtn" @click.stop>
				<div class="item" :class="{'isCheck':isLanguage == 0}" @click="changeLanguage(0)">中文</div>
				<div class="bd1"></div>
				<div class="item" :class="{'isCheck':isLanguage == 1}" @click="changeLanguage(1)">English</div>
			</div>
		</div>
		<div class="boxList">
			<swiper class="swiper" :options="swiperOption" ref="mySwiper">
				<swiper-slide class="swiper-item">
					<div class="item" @click.stop="toStock('in')">
						<img class="itImg" src="../../../../static/FreshCabinet/images/ic_delivery.png" alt="">
						<span>{{Language.Fresh.Delivery[isLanguage]}}</span>
					</div>
					<div class="item" @click.stop="toStock('out')">
						<img class="itImg" src="../../../../static/FreshCabinet/images/ic_delivery.png" alt="">
						<span>{{Language.Fresh.PickUp[isLanguage]}}</span>
					</div>
					<!-- <div class="item">
						<img class="itImg" src="../../../../static/FreshCabinet/images/ic_storage.png" alt="">
						<span>{{Language.LG.InBound[isLanguage]}}</span>
					</div>
					<div class="item">
						<img class="itImg" src="../../../../static/FreshCabinet/images/ic_storage.png" alt="">
						<span>{{Language.LG.InBound[isLanguage]}}</span>
					</div> -->
				</swiper-slide>
				<!-- <swiper-slide class="swiper-item">
					<div class="item">
						<img class="itImg" src="../../../../static/FreshCabinet/images/ic_storage.png" alt="">
						<span>{{Language.LG.InBound[isLanguage]}}</span>
					</div>
				</swiper-slide>
				<swiper-slide class="swiper-item">
					<div class="item">
						<img class="itImg" src="../../../../static/FreshCabinet/images/ic_storage.png" alt="">
						<span>{{Language.LG.InBound[isLanguage]}}</span>
					</div>
				</swiper-slide> -->
				<div class="swiper-button-prev" slot="button-prev" @click.stop></div>
        <div class="swiper-button-next" slot="button-next" @click.stop></div>
			</swiper>
		</div>
		
		<div class="configBtn" v-show="showBtn == true"><el-button type="info" @click.stop="toConfig">修改配置</el-button></div>

		<!--loading -->
		<ELoading v-if="isLoading" :LoadingType="'1'" @click.stop></ELoading>
		
		<!--客服热线-->
		<custService @click.stop></custService>
	</div>
</template>

<script>
	import ELoading from '../assets/Loading.vue'
	import custService from '../../../assets/custService.vue'
	import { EloginApi } from '../../../../static/FreshCabinet/js/api.js'
	import { storage , conLog } from '../../../../static/js/utils/utility.js'
	import zhBgImg from '../../../../static/FreshCabinet/images/main_bg_black_zh.jpg'
	import enBgImg from '../../../../static/FreshCabinet/images/main_bg_black_en.jpg'
	var vm
	export default {
		name:'FreshCabinet',
		data() {
			return {
				configStorage:null,//暂时存放公共配置
				adminToken:'',//token
				
				isLanguage:0,
				Language:'',
				
				pageCount:1,//总页数
				limits:4,//每页显示数
				
				isLoading:false,//是否显示loading组件

				swiperOption: {
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					observer:true, 
					observeParents:true
				},

				showBtn:false,
				num:0,//点击次数
				
				bgImg:'',
			}
		},
		mounted(){
			this.bgImg = this.isLanguage==0 ? zhBgImg : enBgImg
		},
		async created() {
			vm = this
			
			var configStorage = storage.localGetItem('configStorage');
			if(configStorage){
				this.configStorage = configStorage
			}
			var isLanguage = storage.localGetItem('isLanguage');
			if(isLanguage){
				this.isLanguage = isLanguage
			}
			this.Language = this.$Language
		},
		//定义这个sweiper对象  
		computed: {
			swiper() {
				return this.$refs.mySwiper.swiper;  
			}  
		},
		components:{
			ELoading,
			custService
		},
		methods: {
			//跳转到配置页
			toConfig(){
				this.$router.push({
					path:'/CConfigSetting',
					query:{
						'project':true,
					}
				})
			},
			//连续点击屏幕5次
			dblBtn(){
				var that = this;
				this.num++
				if(this.num==1){
					that.timer1=new Date().getTime()/1000
				}
				if(this.num==5){
					this.timer4= new Date().getTime()/1000
					if(that.timer4-that.timer1<=2){
						that.num=0
						that.showBtn=true
						setTimeout(function(){
							that.showBtn = false
						},5000);
					}else {
						this.num=0
					}
				}
			},
			//跳转
			toStock(type){
				var that = this
				this.isLoading = true
				setTimeout(function() {
					that.isLoading = false
					if(type == 'in'){
						vm.$router.push({
							path:'/FreshCabinet/FLogin'
						})
					}else if(type == 'out'){
						vm.$router.push({
							path:'/FreshCabinet/FOutStock'
						})
					}
				}, 2000);
			},
			//中英文切换
			changeLanguage(type){
				this.isLanguage = type
				storage.localSetItem('isLanguage', this.isLanguage);
			}
		},
		watch :{
			isLanguage(newVal,oldVal){
				this.bgImg = newVal == 0 ? zhBgImg : enBgImg
			}
		},
	}
</script>

<style lang="less">
.FreshCabinet{
	height: 100vh;
	.configBtn{
    position: absolute;
    right: 0.94rem;
    top: 0.47rem;
    z-index: 99;
    .el-button{
      height: 0.94rem;
      width: 2.54rem;
      padding: 0;
      font-size: 0.4rem;
      color: #fff;
      font-weight: bold;
      border: none;
      border-radius: 0.12rem;
      line-height:0.94rem;
      background: linear-gradient(#4aaafe, #0769be);
    }
  }
	.boxList{
		position: absolute;
		width: 100%;
		bottom: 2.6rem;
		left: 0;
		// display: flex;
		// align-items: center;
		// justify-content: center;
		.swiper-button-prev{
			width: 0.8rem;
			height: 0.8rem;
			background: url(../../../../static/FreshCabinet/images/arrow_left.png) no-repeat;
			background-size: cover;
			position: absolute;
			top: 0.95rem;
			left: 50%;
			margin-left: -6.4rem;
		}
		.swiper-button-next{
			width: 0.8rem;
			height: 0.8rem;
			background: url(../../../../static/FreshCabinet/images/arrow_right.png) no-repeat;
			background-size: cover;
			position: absolute;
			top: 0.95rem;
			right: 50%;
			margin-right: -6.4rem;
		}
		.swiper{
			height: 2.3rem;
			width: 13.8rem;
			position: absolute;
			left: 50%;
			margin-left: -6.9rem;
			.swiper-item{
				display: flex;
				align-items: center;
				justify-content: center;
				.item{
					font-size: 0.3rem;
					width: 2.3rem;
					height:2.3rem;
					border: 0.06rem solid #fff;
					box-sizing: border-box;
					margin: 0 0.1rem;
					border-radius: 50%;
					background: #04121c;
					display: flex;
					flex-flow: column;
					align-items: center;
					justify-content: center;
					.itImg{
						width: 1.25rem;
						height: 1.25rem;
					}
				}
			}
		}
	}
	.languageBtn{
		display: flex;
		align-items: center;
		justify-content: center;
		padding-top: 0.2rem;
		.lgBtn{
			background-color: #409EFF;
			border-radius: 0.2rem;
			display: flex;
			align-items: center;
			.bd1{
				height: 1rem;
				width: 0.02rem;
				background-color: #555;
			}
			.item{
				margin: 0.2rem;
				width: 2rem;
				height: 0.8rem;
				line-height: 0.8rem;
				text-align: center;
				background: #fff;
				color: #409EFF;
				font-size: 0.4rem;
				&:first-child{
					border-top-left-radius: 0.15rem;
					border-bottom-left-radius: 0.15rem;
				}
				&:last-child{
					border-top-right-radius: 0.15rem;
					border-bottom-right-radius: 0.15rem;
				}
				&.isCheck{
					background: #409EFF;
					color: #fff;
				}
			}
			
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/FreshCabinet/index/index.vue